import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { useEffect } from "react";
import { useSelector , useDispatch } from "react-redux";
import { VENUES, VENUES_OVERVIEW } from "../../const/URL.const";
import { IReduxAppState } from "../../reducers";
import { IDialogChildComponent } from "../../reducers/dialog";
import { VenueProfileView } from "../ui/VenueProfileView";
import { VenueViewList } from "../ui/VenueViewList";
import { setDialogHistory } from "../../actions/dialogHistory"


const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        minWidth: '500px',
        maxWidth: '550px',
        overflow: 'hidden',
        "@media only screen and (max-width: 960px)": {
            minWidth: '250px',
        },
        "@media only screen and (max-width: 600px)": {
            minWidth: 0,
        }
    },
    venueText: {
        paddingLeft: '1rem',
        fontSize: '1.2rem'
    },
    venueList: {
        padding: '1rem',
        maxHeight: '450px',
        overflowX: 'auto'
    }
}));

interface IVenueSelectionProps extends IDialogChildComponent {
    history: any;
}
export function VenueSelectionDialog({ onClose, history }: IVenueSelectionProps) {
    const classNames = useStyles();
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const Venue = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueData);
    const Location = useSelector((state: IReduxAppState) => state.venue[selectedVenueId]?.venueLocation);
    const dialogHistory = useSelector((state:IReduxAppState)=>state.dialogHistory);
    const dispatch = useDispatch();

    useEffect(()=>{
        if(history){
           dispatch(setDialogHistory(history))
        }
    // eslint-disable-next-line    
    },[history])

    function onClickOveriew() {
        if(history){
            history.push(VENUES_OVERVIEW);
        }else{
            dialogHistory.push(VENUES_OVERVIEW)
        }
        onClose();
    }
    function onCloseClick() {
        if(history){
            history.push(VENUES);
        }else{
            dialogHistory.push(VENUES)
        }
        onClose();
    }
    return (
        <div data-component-name="VenueSelectionDialog" className={classNames.root}>
            <VenueProfileView history={history} onClickOveriew={onClickOveriew} venue={Venue!} location={Location!}
                isLoading={!Venue || !Location} />
            <VenueViewList allowImport={Venue?.payment_processor === 'SQUARE'} onClose={onCloseClick} selectedVenue={selectedVenueId} />
        </div>
    )
}

